<template>
	<div id="common" style="background-color: #f2f2f2;">
		
		<el-container>
			<!-- 头部 -->
			<el-header style="height: 10rem;">
				<div class="header">
					<div class="header-div">比赛列表</div>
				</div>
				<div class="search">
					<div class="searchtitle">比赛名称</div>
					<div class="searchtitle1">
						<input class="searchinput" v-model="name" type="text" />
						<img class="searchimg" @click="searchClick()" src="http://jinbangsai.net/shudu/images/%E7%B2%BE%E5%93%81%E9%A2%98%E5%BA%93/u1415.png" />
					</div>
				</div>
			</el-header>  
			<div style="height: 1rem;"></div>
			<el-container style="width: 80%;  margin: auto; padding-bottom:6rem">
				<el-main>
					
					<div class="index-conent-left-connet">
						<div class="list-div" v-for="(item,index) in list" :key="index">
							<router-link :to="'/game/details?id='+item.id">
								<img :src="item.img" />
								<div class="list-div-title">主办方：{{item.name}}</div>
								<div class="list-div-bao">
									<div>正在报名</div>
									<div class="enter">进入</div>
								</div>
							</router-link>
						</div>
					
					</div>
				</el-main>
			</el-container>
		</el-container>
		
	</div>
	
	


</template>

<script>
	export default {
	    data() {
			return {
				type : '/author_question',
				list : [],
				name : ''
			}
	    },
		created() {
			let that = this;
			that.all({});
			
		},
		methods:{
			searchClick(){
				let that = this;
				that.all({name:that.name});
			},
			all($where){
				let that = this;
				that.$http('get','/api/v1/game/listAll',$where) .then(function (res) {
					that.list = res.data.list;
				});
			}
		},
	}
	
</script>

<style lang="less">
	@import  '../../../common/css/search.less';
	.el-header {
		height: 10rem;
		padding: 0;
	}
	.lefttype {
		color: #3d3e40 !important;
		font-size: 0.86rem !important;
	}
	.header {
		color: #FFFFFF;
		background-color: rgba(9, 7, 35, 1);
		width: 100%;
		height: 10rem;
		.header-div {
			width: 60%;
			margin: auto;
			display: flex;
			padding-top: 2rem;
			font-style: normal;
			font-size: 1.5rem;
			color:#F2F2F2;
			font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
		}
		
	}
	.el-aside {
		margin-left: 1rem;
		height:23.5rem;
		div {
			font-size: 0.6rem;
			width: 100%;
			height: 2rem;
			line-height: 2rem;
			border-bottom: 1px solid #e9e9e9 ;
			color: #7F7F7F;
		}
	}
	.index-conent-left-connet {
		min-height: 11rem;
		display: flex;
		flex-wrap: wrap;
		margin-top: 1rem;
		.list-div {
			min-height: 9.5rem;
			background-color: #FFFFFF;
			margin-left: 1rem;
			margin-right: 1rem;
			width: 10rem;
			margin-top: 1rem;
			font-size: 0.5rem;
			img {
				width: 100%;
				height: 8rem;
				
			}
			.list-div-title {
				padding-top: 0.3rem;
				padding-left: 0.6rem;
				height: 1rem;
				overflow: hidden;
				text-overflow:ellipsis;
				white-space: nowrap;
				
			}
			.list-div-bao {
				padding-top: 0.3rem;
				padding-left: 0.6rem;
				display: flex;
				padding-bottom: 0.6rem;
				font-size: 0.6rem;
				.enter {
					margin-left: auto;
					padding-right: 0.3rem;
				}
			}
		}
	}
	
</style>
